<template>
  <div
    :style="{
      flex,
      minHeight: `${minHeight}px`,
      minWidth: `${minWidth}px`,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SplitterPanel',
  props: {
    basis: {
      type: Number,
      default: null,
    },
    separatorSpace: {
      type: Number,
      required: true,
    },
    minHeight: {
      type: Number,
      default: 0,
    },
    minWidth: {
      type: Number,
      default: 0,
    },
    defaultWidth: {
      type: Number,
      default: 0,
    },
    collapseBelow: {
      type: Number,
      default: 0,
    },
    // "Over" drag before it actually collapses
    collapseBuffer: {
      type: Number,
      default: 0,
    },
    fixedWidth: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    correctedBasis() {
      return this.fixedWidth ? `${this.basis}px` : `${this.basis}%`;
    },

    calcBasis() {
      return `calc(${this.correctedBasis} - ${this.separatorSpace}px)`;
    },

    flex() {
      return this.fixedWidth ? `0 0 ${this.calcBasis}` : `1 1 ${this.calcBasis}`;
    },
  },
};
</script>
